import * as React from "react"
import * as CommonUtils from "../../utils"
import * as Model from "../../../../../model"
import * as Conf from "../../../configuration"

export default class PpiGeneralTable extends React.Component<Props> {
	private readonly valueColumnWidth: number

	constructor(props: Readonly<Props>) {
		super(props)
		// this.valueColumnWidth = (props.width - props.labelColumnWidth - 1)
		// / props.ppiYears.length
	}

	render() {
		const data = this.props.data
		const id = this.props.id

		const dataRow = this.filterDataRow(data)
		const filteredWidth = this.calculateWidth(dataRow)

		// const labelColumnWidth = this.props.labelColumnWidth
		const labelColumnWidth = this.props.labelColumnWidth > filteredWidth ? this.props.labelColumnWidth : filteredWidth
		const valueColumnWidth = (this.props.width - labelColumnWidth) / this.props.ppiYears.length
		const ppiYears = this.props.ppiYears
		const tableConf = this.props.tableConfiguration

		return <table id={id}>
			<thead>
				<tr>
					<th data-pptx-width={labelColumnWidth}
					style={{ ...tableConf.header }}></th>

					{ppiYears.map((ppiYear, yearIndex) =>
					<th data-pptx-width={valueColumnWidth}
					key={yearIndex}
					style={{ ...tableConf.header }}>{ppiYear.year}</th>)}
				</tr>
			</thead>

			{<tbody>
				{data.fctva && this.createDataGroupTableRows(data.fctva, ppiYears, tableConf)}
			</tbody>}

			<tbody>
				{data.receipts && this.createDataGroupTableRows(data.receipts, ppiYears, tableConf)}
			</tbody>

			<tbody>
				{data.expense && this.createDataGroupTableRows(data.expense, ppiYears, tableConf)}
			</tbody>

			<tbody>
				{data.ratios && this.createDataGroupTableRows(data.ratios, ppiYears, tableConf)}
			</tbody>

			{data.totalResult && this.createPpiTotalResultTableBody(data.totalResult, ppiYears, tableConf)}
		
		</table>
	}

	private createDataGroupTableRows(
		dataGroup: DataGroup,
		ppiYears: Model.PpiYear[],
		tableConf: Conf.TableConfiguration,
		depth = 0
	): React.ReactNodeArray {
		const rows: React.ReactNodeArray = []
		let index = 0
		
		if (dataGroup.title) {
			rows.push(<tr key={index++}>
				<th colSpan={ppiYears.length + 1} style={{ ...tableConf.header }}>
					{dataGroup.title}
				</th>
			</tr>)
		}

		rows.push(dataGroup.data.map(
			(data, rowIndex) =>
				isDataGroup(data)
				? this.createDataGroupTableRows(data, ppiYears, tableConf, depth + 1)
				: this.props.enableHideZeroLines
				? !CommonUtils.isArrayAllValuesZero(data.values) &&
					this.createTableRow(
					data,
					rowIndex + index++,
					ppiYears,
					tableConf,
					depth
					)
				: this.createTableRow(
					data,
					rowIndex + index++,
					ppiYears,
					tableConf,
					depth
					)
			)
    	)


		if (dataGroup.total) {
			rows.push(<tr key={index++}>
				<td style={{ ...tableConf.subtotal }}>
					{dataGroup.total.label}
				</td>

				{ppiYears.map((ppiYear, yearIndex) => {
					const value = dataGroup.total.values[yearIndex] || 0
					return <td
					key={yearIndex}
					style={{ ...tableConf.subtotal, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(
							this.props.locale,
							this.props.currency,
							value,
							this.props.roundness
						)}
					</td>
				})}
			</tr>)
		}

		return rows
	}

	private createPpiTotalResultTableBody(
		dataRow: DataRow,
		ppiYears: Model.PpiYear[],
		tableConf: Conf.TableConfiguration
	): React.ReactNode {
		return <tbody>
			<tr>
				<td colSpan={ppiYears.length + 1} style={{ ...tableConf.header}}>
					{dataRow.label}
				</td>
			</tr>

			<tr>
				<td style={{ ...tableConf.subtotal }}>
					{dataRow.label}
				</td>

				{ppiYears.map((ppiYear, yearIndex) => {
					const value = dataRow.values[yearIndex] as number || 0
					return <td
					key={yearIndex}
					style={{ ...tableConf.subtotal, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(
							this.props.locale,
							this.props.currency,
							value,
							this.props.roundness
						)}
					</td>
				})}
			</tr>
		</tbody>
	}

	private createTableRow(
		row: DataRow,
		index: number,
		ppiYears: Model.PpiYear[],
		tableConf: Conf.TableConfiguration,
		depth = 0
	): React.ReactNode {
		const originTitleArray  = row.label.split("(");
		const titleValue = originTitleArray[0];
		
		return <tr key={index}>
			<td style={row.valuesType == ValuesType.Percentage ?{ ...tableConf.ratio }:{ ...tableConf.common }}>{titleValue}</td>

			{ppiYears.map((ppiYear, yearIndex) =>
				this.createTableCell(
					row.values[yearIndex], tableConf, row.valuesType, yearIndex, depth)
			)}
		</tr>
	}

	private createTableCell(
		value: number | string,
		tableConf: Conf.TableConfiguration,
		valuesType?: ValuesType,
		key?: number,
		depth = 0
	): React.ReactNode {
		if ("string" === typeof value)
			return <td key={key} style={{ ...tableConf.common }}>
				{value}
			</td>

		switch (valuesType) {
			case ValuesType.Currency:
				return <td key={key} style={{...tableConf.common, ...tableConf.numeric }}>
					{CommonUtils.formatCurrency(
						this.props.locale,
						this.props.currency,
						value || 0,
						this.props.roundness
					)}
				</td>
			case ValuesType.Percentage:
				return <td key={key}
				style={{ ...tableConf.ratio, ...tableConf.numeric }}>
					{new Intl.NumberFormat(this.props.locale, {
						maximumFractionDigits: 2,
						style: "percent"
					}).format(value || 0)}
				</td>
		}
	}

	private calculateWidth(data: (DataRow)[]) : number{

		const lentghData = (Math.max(...(data.map(el => el.label.split("(")[0].length))) * 0.07)
		return lentghData
	}

	private filterDataRow(data: Data) : DataRow[] {
		let expenseData = data.expense && data.expense.data.filter(el => !isDataGroup(el))as DataRow[] || []
		let fctvaData = data.fctva && data.fctva.data.filter(el => !isDataGroup(el))as DataRow[] || []
		let receiptsData = data.receipts && data.receipts.data.filter(el => !isDataGroup(el))as DataRow[] || []

		const dataRow = [...expenseData,...fctvaData,...receiptsData]
		return dataRow
	}
}

export enum ValuesType {
	Currency,
	Percentage
}

export interface Data {
	expense: DataGroup
	fctva: DataGroup
	ratios: DataGroup
	receipts: DataGroup
	totalResult: DataRow
}

export interface DataGroup {
	data: (DataGroup | DataRow)[]
	title?: string
	total?: Total
}

export interface DataRow {
	label: string
	values: (number | string)[]
	valuesType: ValuesType
}

export interface Props {
	currency: string
	data: Data
	id: string
	labelColumnWidth: number
	locale: string
	ppiYears: Model.PpiYear[]
	roundness: Conf.RoundnessValue
	enableHideZeroLines: boolean
	tableConfiguration: Conf.TableConfiguration
	width: number
}

export interface Total {
	label: string
	values: number[]
}

function isDataGroup(item: DataGroup | DataRow): item is DataGroup {
	return undefined !== (item as DataGroup).data
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/ppi-generator/ppi-general-table/index.tsx